import { render } from "./Beikostberatung.vue?vue&type=template&id=462408c4&scoped=true"
import script from "./Beikostberatung.vue?vue&type=script&lang=js"
export * from "./Beikostberatung.vue?vue&type=script&lang=js"

import "./Beikostberatung.vue?vue&type=style&index=0&id=462408c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462408c4"]])

export default __exports__